import React from 'react';
import { useAuth } from '../hooks/useAuth';
import Login from './Login';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <div>
      {/* User menu bar */}
      <div style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '12px 20px',
        borderBottom: '1px solid #ddd',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {user?.picture && (
            <img 
              src={user.picture} 
              alt="Profile"
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                border: '2px solid white',
                boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
              }}
            />
          )}
          <div>
            <div style={{ color: 'white', fontSize: '14px', fontWeight: '500' }}>
              {user?.name || user?.email?.split('@')[0]}
            </div>
            <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: '12px' }}>
              {user?.email}
            </div>
          </div>
        </div>
        <LogoutButton />
      </div>
      
      {/* Protected content */}
      {children}
    </div>
  );
};

const LogoutButton = () => {
  const { logout } = useAuth();

  return (
    <button
      onClick={logout}
      style={{
        background: 'rgba(255,255,255,0.2)',
        color: 'white',
        border: '1px solid rgba(255,255,255,0.3)',
        padding: '8px 16px',
        borderRadius: '6px',
        fontSize: '12px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        backdropFilter: 'blur(4px)'
      }}
      onMouseEnter={(e) => {
        e.target.style.background = 'rgba(255,255,255,0.3)';
        e.target.style.borderColor = 'rgba(255,255,255,0.5)';
      }}
      onMouseLeave={(e) => {
        e.target.style.background = 'rgba(255,255,255,0.2)';
        e.target.style.borderColor = 'rgba(255,255,255,0.3)';
      }}
    >
      Sign Out
    </button>
  );
};

export default ProtectedRoute;
